export const GET_USER_INFO = "GET_USER_INFO";
export const GET_DELIVERY_CHANNEL_INFO = "GET_DELIVERY_CHANNEL_INFO";